// imported first to set webpack public path
import React from 'react';

import ExternalPageRedirect from 'client/components/ExternalPageRedirect';
import PageNotFoundPage from 'client/components/PageNotFoundPage';
import { DatadogAction } from 'client/utils/logging';
import { LogRenderDatadogAction } from 'client/components/LogRenderDatadogAction';
import { useClientConfig } from 'client/contexts/ClientConfigContext';
/**
 * This component only performs the routing, and any access-control logic must be
 * added to the corresponding component getting rendered. This is suggested to
 * separate the concerns between routing and feature authorization, where the latter
 * is better handled by the corresponding feature / component.
 *
 * tl;dr - this component shouldn't contain any logic, just routing
 *
 * - log all page loads
 * - render loading page while preparing data
 * - create routes and components
 * - create possibly conditional redirects
 */
export const WorkerComplianceRoutes = (): JSX.Element => {
    const { flexAcquisitionUrl } = useClientConfig();

    // Redirect everyone to the acquisition URL from config
    if (flexAcquisitionUrl) {
        return (
            <LogRenderDatadogAction action={DatadogAction.workerRedirectedToCorrectTaskList}>
                <ExternalPageRedirect redirectUrl={flexAcquisitionUrl} />
            </LogRenderDatadogAction>
        );
    }

    // Fallback to PageNotFoundPage if no acquisition URL is configured
    return <PageNotFoundPage />;
};
